import Nossr from '../helpers/nossr'
import React from 'react'
import { useRouter } from 'next/router'
import styled from 'styled-components';
import { breakpoint } from '../layout/styles'

const YotpoReviews = ({ data } : any) => {
  const router = useRouter();
  const { component } = data;

  // Check if data.product_data exists before destructuring
  if (!data.product_data) return null;

  const { product, ref } = data.product_data;

  // Additional check for product
  if (!product) return null;

  if(!component.reviews) return null;
  return (
    // @ts-ignore
    <Nossr>
      <YotpoContainer>
        <div
          className="yotpo yotpo-main-widget"
          data-product-id={product.sku}
          data-name={product.title}
          data-url={router.asPath}
          data-image-url={product.images?.[0]?.url}
          ref={ref}
        />
      </YotpoContainer>
    </Nossr>
  )
}

export default YotpoReviews;

export const YotpoContainer = styled.div<any>`
  @media screen and ${breakpoint.mobile} {
    width: 100% !important;
  }
  @media screen and ${breakpoint.tablet} {
    width: 80% !important;
  }
  @media screen and ${breakpoint.tablet} {
    width: 740px !important;
  }
  margin: 0 auto;
  padding: 36px;
  .yotpo {
    &-main-widget {
      a,
      a:hover{
        color: var(--yotpo-text-color);
      }
    }
    
    &-label {
      display: none;
    }

    &-nav-wrapper,
    &-nav-wrapper span,
    &-icon,
    &-sum-reviews,
    &-sum-reviews > span,
    &-user-name,
    &-header-title,
    &-mandatory-explain,
    .y-label,
    .y-input {
      color: var(--yotpo-text-color) !important;
    }

    &-nav-wrapper {
      border-bottom-color: var(--yotpo-border-color) !important;
    }
    
    &-icon {
      font-size: 1.25rem !important;
    }

    &-star-distribution-graph-background {
      background-color: var(--yotpo-star-distribution-graph-background) !important;
    }

    &-star-distribution-graph-score {
      background-color: var(--yotpo-star-distribution-graph-score) !important;
    }
    
    &-default-button {
      background-color: var(--yotpo-default-button-background-color) !important;
      color: var(--yotpo-default-button-background-color) !important;
      
      span {
        color: var(--yotpo-default-button-color) !important;
      }
    }
    
    &-submit{
      color: var(--yotpo-submit-button-color) !important;
    }
    
    input[type=button].primary-color-btn:hover {
      background-color: var(--yotpo-primary-color-btn) !important;
    }
    
    .write-review {
      color: var(--yotpo-write-review) !important;
    }
    
    &-page-element {
      color: var(--yotpo-pagination-color) !important;
    }
  }
`
